import React, { useEffect, useState, useRef, useCallback  } from 'react';
import { Container } from 'react-bootstrap';
import { Link } from "react-router-dom";
import OwlCarousel from 'react-owl-carousel';
import 'owl.carousel/dist/assets/owl.carousel.css';
import 'owl.carousel/dist/assets/owl.theme.default.css';
import * as AuthVerify from '../../lib/common';
import Axios from '../../lib/axios/axiosInstance';
import './RelatedProductsSlider.styles.css';
import {BASE_URL} from '../../lib/constant';
import products from '../../mockups/productList.json'

const options = {
  margin: 5,
  responsiveClass: true,
  autoPlay:true,
  nav: false,
  dots: false,
  loop: false,
  navText: ["<span></span>", "<span></span>"],
  responsive: {
    0: {
      items: 1,
    },
    400: {
      items: 1,
    },
    600: {
      items: 2,
    },
    700: {
      items: 3,
    },
    1000: {
      items: 4,

    }
  },
};

const RelatedProductsSlider = () => {
  const [recentProducts, setRecentProducts] = useState(false); 
  const [needToRender, setNeedToRender] = useState(false);
  
  useEffect(() => {
    AuthVerify.recentsProducts().then(async (data) => {
      if(data){
        // RECENTLY VIEWED
        // api/product/viewed
        await Axios.post(`/product/viewed`,{
            "items":data
        })
        .then(function (response) {
            if (response && response.data?.data?.items) {
              setRecentProducts(response.data?.data?.items);
            }
            else {
              setRecentProducts([]);
              return false;
            }
        })
        .catch(function (error) {
          setRecentProducts([]);
          return false;
        }); 
      }
    });
}, [])

const addToWishlist = async (matnum,wishlist) => {
  if(wishlist){
    await AuthVerify.removeFromWishlist(matnum);
  }else{
    await AuthVerify.addToWishlist(matnum);
  }
  window.setProductActiveOrNot(matnum,wishlist);
  // let oldProducts=needToRender;
  // oldProducts.map(item=>{
  //     if(item.matnum==matnum){
  //         item.wishlist=!wishlist;
  //     }
  // })
  // setNeedToRender(oldProducts);
}

  const CarouselData = () => {
    return (<OwlCarousel id="related-products-slider" className="product-flexslider hidden-buttons owl-theme" {...options}>
    {
      recentProducts && recentProducts?.map((product,i) => (

        <div className='item' key={i}>
          <div className="item-inner" >
              <div className="item-img">
                  <div className="item-img-info">
                      <Link
                          className="product-image"
                          title={product?.matname} 
                          to={"/product-detail?matnum="+product?.matnum}
                      >
                          <img
                              alt={product?.matname}
                              // src={img03}
                              // src={BASE_URL+product?.imageurl}
                              src={AuthVerify.getImageLink(product?.imageurl)}
                              height="358px"
                          />
                      </Link>
                      <div className={(product?.status === "New" && "new-label new-top-left") ||
                          (product?.discount !== null && "hot-label hot-top-left") ||
                          (product?.stock === "Sold out" && "soldout-label new-top-left") || "hidden"}>
                          {(product?.status === "New" && product?.status) ||
                              ((product?.discount || '0') + "% off") ||
                              (product?.stock === "Sold out" && product?.stock) || ""}</div>
                      {/* <div className={product?.discount !== null || "hidden"}>{product?.discount}</div> */}
                      <div className={product?.contract ? "contract-label" : "hidden"}>{product?.contract && "contract"}</div>
                      <div className="jtv-box-hover">
                          <ul className="add-to-links">
                              <li>
                                  <Link className="link-quickview" to="/product-list">
                                      <i className="icon-magnifier-add icons"></i>
                                      <span className="hidden">Quick View</span>
                                  </Link>
                              </li>
                              <li>
                                  <button className={`link-wishlist matnum-${product?.matnum} ${product.wishlist?'active':''}`} onClick={()=>addToWishlist(product?.matnum, product.wishlist)} style={{background:"none",border:"none"}}>
                                      <i className="icon-heart icons"></i>
                                      <span className="hidden">Add to Wishlist</span>
                                  </button>
                              </li>
                              <li>
                                  <Link className="link-compare" to="/product-list">
                                      <i className="icon-shuffle icons"></i>
                                      <span className="hidden">Compare</span>
                                  </Link>
                              </li>
                          </ul>
                      </div>
                  </div>
              </div>
              <div className="item-info">
                  <div className="info-inner">
                      <div className="item-title" style={{padding:"0 7px"}}>
                          <Link title={product.matname} to={"/product-detail?matnum="+product?.matnum}>
                              {product.matname}
                          </Link>
                      </div>
                      <div className="item-content">
                          <div className="rating">
                              <i className={product.rating>0?"fa fa-star":"fa fa-star-o"}></i>
                              <i className={product.rating>1?"fa fa-star":"fa fa-star-o"}></i>
                              <i className={product.rating>2?"fa fa-star":"fa fa-star-o"}></i>
                              <i className={product.rating>3?"fa fa-star":"fa fa-star-o"}></i>
                              <i className={product.rating>4?"fa fa-star":"fa fa-star-o"}></i>
                          </div>
                          <div className="item-price">
                              <div className="price-box">
                                  <span className="regular-price">
                                      <span className="price">{`S$${product.sellingprice} (w/GST S$${product.gstprice})`}</span>
                                      {product.promoprice && 
                                      <>
                                          <br/>
                                          <span  style={{color:'grey',textDecoration:'line-through', fontlastProductPositionLeft:'14px'}} className="price">U.P. S${product.usualprice}</span>
                                      </>
                                      }
                                      
                                  </span>
                              </div>
                          </div>
                          <div className="action">
                              <button
                                  className="button btn-cart"
                                  type="button"
                                  title=""
                                  data-original-title="Add to Cart"
                                  onClick={()=>AuthVerify.addTocart(product)}
                              >
                                  <span>Add to Cart</span>
                              </button>
                          </div>
                      </div>
                  </div>
              </div>
          </div>
        </div>
      ))}
  </OwlCarousel>)
  }

  return (
    <Container>
      <div className="related-section">
        <div className="slider-items-products">
          <div className="related-block">
            {recentProducts && 
            <div className="jtv-block-inner">
              <div className="block-title">
                <h2>Recently Viewed Products</h2>
              </div>
            </div>
            }

            <div className="slider-items slider-width-col4 products-grid block-content">
              <CarouselData/>
            </div>
          </div>
        </div>
      </div>
    </Container>
  );
};

export default RelatedProductsSlider;
